{{ descriptionKey | translate }}

<ng-container *nzModalFooter>
  <button nz-button (click)="handleCancel()">
    {{ 'general.cancel' | translate }}
  </button>

  <button nz-button (click)="handleMoveSelectedItem()">
    {{ moveSelectedItemKey | translate }}
  </button>

  <button nz-button nzType="primary" (click)="handleMoveAllItems()">
    {{ moveAllItemsKey | translate }}
  </button>
</ng-container>
